export default __webpack_public_path__ + "static/logo-principal-16f85ef673dcce8167702bb5664076ae.svg";